import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IApproveGrammarClipV1Response } from './approve-grammar-clip-v1-response';
import { approveGrammarClipV1ResponseSchema } from './approve-grammar-clip-v1-response';

export async function approveGrammarClipV1Api(
  linkId: number,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IApproveGrammarClipV1Response>> {
  return postRequest<IApproveGrammarClipV1Response>({
    path: `/sys/grammar/v1/triage/${linkId}/approve`,
    schema: approveGrammarClipV1ResponseSchema,
    options,
  });
}
